const Home = {
  template: `
    <section id="home">

      <div class="headlines">

        <h2 class="headlines-h2">Part B(OOK)</h2>

        <h3 class="headlines-h3">Introduction</h3>

      </div>

      <main class="container">

        <p class="introduction">Part B(OOK) of this publication consists of four essays in which the participants in the research project RepRecDigit – Jesper Olsson, Jonas Ingvarssson, Jakob Lien, and Cecilia Lindhé – try to investigate the affordances of digital technologies for methodological and epistemic experimentation in the humanities. In collaboration with programmers and designers Maximilian George, William Hesseldahl, and Christopher West, we have explored how the writing of an academic essay might be expanded and differentiated with a curious eye at the media specificities and materialities of digital devices, interfaces, and environments. Our intention is to foster potentially new modes of reading and producing knowledge – an ambition that depends on the encounters, participations, and ways of sharing that BOOK hopefully engenders.</p>

        <router-link class="book-container" :to="{ name: 'jesper-1', params: { forceShowHeader: true } }">

          <div class="book book--jesper">

            <div class="book-header">

              <p class="book-header-original">A R/R/D Original</p>

              <hr>

              <h1 class="book-header-title">List &rarr;<br>Program &rarr;<br>Ecology:</h1>
              <p class="book-header-subtitle">Digital/Post-Digital in Swedish Poetry</p>

              <hr>

              <p class="book-header-author">Jesper Olsson</p>

            </div>

            <figure class="book-illustration-container">
              <img class="book-illustration" src="/static/jesper-illustration.svg">
            </figure>

          </div>

        </router-link>

        <div class="book-container book-container--inactive">

            <div class="book book--cilla">

              <div class="book-header">

                <p class="book-header-original">A R/R/D Original</p>

                <hr>

                <h1 class="book-header-title">A short title</h1>
                <p class="book-header-subtitle">A longer sub-title</p>

                <hr>

                <p class="book-header-author">Cecilia Lindhé</p>

              </div>

              <figure class="book-illustration-container">
                <img class="book-illustration" src="/static/cilla-illustration.svg">
              </figure>

            </div>

        </div>

        <div class="book-container book-container--inactive">

            <div class="book book--jonas">

              <div class="book-header">

                <p class="book-header-original">A R/R/D Original</p>

                <hr>

                <h1 class="book-header-title">A short title</h1>
                <p class="book-header-subtitle">A longer sub-title</p>

                <hr>

                <p class="book-header-author">Jonas Ingvarsson</p>

              </div>

              <figure class="book-illustration-container">
                <img class="book-illustration" src="/static/jonas-illustration.svg">
              </figure>

            </div>

        </div>

        <div class="book-container book-container--inactive">

            <div class="book book--jakob">

              <div class="book-header">

                <p class="book-header-original">A R/R/D Original</p>

                <hr>

                <h1 class="book-header-title">A short title</h1>
                <p class="book-header-subtitle">A longer sub-title</p>

                <hr>

                <p class="book-header-author">Jakob Lien</p>

              </div>

              <figure class="book-illustration-container">
                <img class="book-illustration" src="/static/jakob-illustration.svg">
              </figure>

            </div>

        </div>

      </main>

    </section>
  `
}

export default Home
